import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useOpenState } from "../contexts/OpenContext";

const Header = () => {
  const { state, dispatch, Login } = useOpenState();
  const navigate = useNavigate();

  return (
    <header
      className={`fixed top-0 left-0 h-[80px] bg-[#fff] w-full z-20 ${
        state.header ? "hidden" : "block"
      }`}
    >
      <div className="text-gray-100 px-4 flex items-center justify-between py-2 h-[80px] shadow-md">
        <div
          className="text-[#00947d] md:hidden"
          onClick={() =>
            dispatch({ type: "CHANGE_TOGGLE", data: !state.toggle })
          }
        >
          {state.toggle ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              width={35}
              height={35}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              width={35}
              height={35}
              viewBox="0 0 24 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line y1={1} x2={17} y2={1} stroke="#00947d" strokeWidth={2} />
              <line y1={15} x2={24} y2={15} stroke="#00947d" strokeWidth={2} />
              <line y1={8} x2={21} y2={8} stroke="#00947d" strokeWidth={2} />
            </svg>
          )}
        </div>
        <img src="/img/logo.png" alt="" className="h-[40px] md:hidden" />
        <div className="hidden md:flex w-full justify-between items-center max-w-7xl mx-auto">
          <div className="flex items-center justify-between w-[1280px] text-xs md:text-sm lg:text-base cursor-default md:px-4 uppercase">
            <div
              className="flex items-center justify-center cursor-pointer min-w-[289px] w-[289px]"
              onClick={() => {
                dispatch({ type: "CHANGE_TOGGLE", data: false });
                dispatch({
                  type: "SET_PUBLIC_DATA",
                  data: { selected_menu: state?.menu[0]?.id },
                });
                navigate("/");
              }}
            >
              <img src="/img/logo.png" alt="" className="h-[50px] w-[289px]" />
            </div>
            <div className="md:flex md:items-end uppercase text-xs font-bold mt-12 w-[400px] lg:w-[600px] xl:w-auto overflow-auto menu-scroll select-none">
              {state.menu.length > 0 &&
                state.menu.map((el, index) => {
                  return (
                    <div
                      key={index}
                      className={`whitespace-nowrap cursor-pointer block no-underline px-2 hover:text-[#00947d] ${
                        el.id === state.selected_menu
                          ? "text-[#00947d]"
                          : "text-black"
                      }`}
                      onClick={() => {
                        navigate("/");
                        dispatch({
                          type: "SET_PUBLIC_DATA",
                          data: { selected_menu: el.id },
                        });
                      }}
                      title={el.category_name}
                    >
                      {el.category_short}
                      <div
                        className={`h-[4px] w-full ${
                          el.id === state.selected_menu ? "bg-[#00947d]" : ""
                        } mt-3`}
                      />
                    </div>
                  );
                })}
              {state.loggedIn ? (
                <Link
                  to="/admin"
                  className="whitespace-nowrap cursor-pointer block no-underline px-2 hover:text-[#00947d] text-black"
                >
                  Админ
                  <div className={`h-[4px] w-full mt-3`} />
                </Link>
              ) : (
                <a
                  href="/"
                  className="whitespace-nowrap cursor-pointer block no-underline px-2 hover:text-[#00947d] text-black"
                  onClick={(e) => {
                    e.preventDefault();
                    Login();
                  }}
                >
                  Нэвтрэх
                  <div className={`h-[4px] w-full mt-3`} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default React.memo(Header);
